import React, { useEffect, useMemo } from "react";
import { Box } from "@mui/material";

const defaultEmployeeCategoryData1 = [
  {
    EmployeeCategory: "Executive Management",
    Group1: "",
    Group2: "",
    Group3: "",
    NotDisclosed: "",
  },
  {
    EmployeeCategory: "Non-Executive Management",
    Group1: "",
    Group2: "",
    Group3: "",
    NotDisclosed: "",
  },
  {
    EmployeeCategory: "Professionals",
    Group1: "",
    Group2: "",
    Group3: "",
    NotDisclosed: "",
  },
  {
    EmployeeCategory: "All Other Employees",
    Group1: "",
    Group2: "",
    Group3: "",
    NotDisclosed: "",
  },
];

const EmployeeCategoryTable1 = ({
  employeeCategoryTable1,
  setEmployeeCategoryTable1,
}) => {
  const tableData = useMemo(() => {
    if (
      Array.isArray(employeeCategoryTable1) &&
      employeeCategoryTable1.length === 4
    ) {
      return employeeCategoryTable1;
    }
    return defaultEmployeeCategoryData1;
  }, [employeeCategoryTable1]);

  useEffect(() => {
    if (!employeeCategoryTable1 || employeeCategoryTable1.length === 0) {
      setEmployeeCategoryTable1(defaultEmployeeCategoryData1);
    }
  }, [employeeCategoryTable1, setEmployeeCategoryTable1]);

  const handleInputChange = (rowIndex, field, value) => {
    const updatedData = [...tableData];
    updatedData[rowIndex][field] = value;
    setEmployeeCategoryTable1(updatedData);
  };

  return (
    <div
      style={{
        marginTop: "20px",
        border: "1px solid #000",
        borderRadius: "8px",
        overflow: "hidden",
        width: "100%",
      }}
    >
      <Box sx={{ width: "100%" }}>
        <table
          style={{
            minWidth: "800px",
            width: "100%",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr
              style={{
                backgroundColor: "#D3C9CE",
                color: "#000",
                fontWeight: "bold",
              }}
            >
              <th style={tableHeaderStyle}>Employee Category</th>
              <th style={tableHeaderStyle}>Group 1 (%)</th>
              <th style={tableHeaderStyle}>Group 2 (%)</th>
              <th style={tableHeaderStyle}>Group 3 (%)</th>
              <th style={tableHeaderStyle}>Not Disclosed (%)</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, index) => (
              <tr key={index}>
                <td
                  style={{
                    ...tableCellStyle,
                    backgroundColor: "#f5f5f5",
                    fontWeight: "bold",
                  }}
                >
                  {row.EmployeeCategory}
                </td>
                {["Group1", "Group2", "Group3", "NotDisclosed"].map((field) => (
                  <td key={field} style={tableCellStyle}>
                    <input
                      type="number"
                      value={row[field]}
                      onChange={(e) =>
                        handleInputChange(index, field, e.target.value)
                      }
                      style={inputFieldStyle}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </div>
  );
};

const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const inputFieldStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

export default EmployeeCategoryTable1;
